import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/common/tab-list.css';

import '../css/promotion/promotion-category.css';
import '../css/card-block.css';
import '../css/promotion/card-block.css';
import '../css/promotion/book-button.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { uploadUri } from './appConfig';
import getPromotionList from './request/promotionList';
import generateLinkCard from './promotion/generateLinkCard';
import setCategory from './promotion/setCategory';
import hideLoadingImage from './common/hideLoadingImage';

setup();

getPromotionList()
	.then((json) => {
		json.promotions.forEach((item) => {
			document.querySelector('.section-block > .content').appendChild(
				generateLinkCard(
					item.id,
					item.type,
					item.title,
					item.date_start,
					`${uploadUri}/${item.thumb}`,
					item.link,
				),
			);
		});
	})
	.then(() => {
		hideLoadingImage();
	});

setCategory(window.location.href.split('#')[1]);

Array.from(document.querySelectorAll('.promotion-category > .item'))
	.forEach((item) => {
		item.addEventListener('click', (e) => {
			document.querySelector('.content-wrapper').setAttribute(
				'class',
				`content-wrapper -${e.target.getAttribute('class').split('-')[1]}`,
			);
		});
	});



// WEBPACK FOOTER //
// ./src/js/promotions.js